(function () {
  'use strict';

  angular
    .module('flightReports')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('flightReports', {
        url: '/flight-reports',
        views: {
        	'flightReportsView' : {
        		templateUrl: 'flight-reports/views/flight-reports.tpl.html',
                controller: 'FlightReportsCtrl',
                controllerAs: 'flightReport'
        	}
        }
      });
  }
}());
